module.exports = __webpack_public_path__ + "static/media/funchal-16.b4dd1588.svg";